module.exports = __webpack_public_path__ + "img/image6.b2bb60e9.png";